document.addEventListener("DOMContentLoaded", function () {
    const menuIcon = document.querySelector(".mf_header-menu-icon");
    const header = document.querySelector(".mf_header");
    const mobileBlock = document.querySelector(".mf_heading-mobile-block");

    if (menuIcon && header) {
        menuIcon.addEventListener("click", function () {
            header.classList.toggle("active");
            if (header.classList.contains("active")) {
                mobileBlock.style.maxHeight = mobileBlock.scrollHeight + "px";
            } else {
                mobileBlock.style.maxHeight = "0px";
            }
        });
    }
});
